import * as annotations from './annotations';
import { MakeObModelSymbol } from './environment';
import { createObservable } from './internals';
export function observable(target) {
    return createObservable(null, null, target);
}
observable.box = annotations.box;
observable.ref = annotations.ref;
observable.deep = annotations.observable;
observable.shallow = annotations.shallow;
observable.computed = annotations.computed;
observable[MakeObModelSymbol] = annotations.observable;
//# sourceMappingURL=observable.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/reactive-vue/node_modules/@formily/reactive/esm/observable.js
// module id = null
// module chunks = 